var items = {
  "block.minecraft.air": "воздух",
  "block.minecraft.stone": "камень",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "полированный гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "полированный диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "полированный андезит",
  "block.minecraft.grass_block": "дёрн",
  "block.minecraft.dirt": "земля",
  "block.minecraft.coarse_dirt": "каменистая земля",
  "block.minecraft.podzol": "подзол",
  "block.minecraft.crimson_nylium": "багровый нилий",
  "block.minecraft.warped_nylium": "искажённый нилий",
  "block.minecraft.cobblestone": "булыжник",
  "block.minecraft.oak_planks": "дубовые доски",
  "block.minecraft.spruce_planks": "еловые доски",
  "block.minecraft.birch_planks": "берёзовые доски",
  "block.minecraft.jungle_planks": "доски из тропического дерева",
  "block.minecraft.acacia_planks": "акациевые доски",
  "block.minecraft.dark_oak_planks": "доски из тёмного дуба",
  "block.minecraft.crimson_planks": "багровые доски",
  "block.minecraft.warped_planks": "искажённые доски",
  "block.minecraft.oak_sapling": "саженец дуба",
  "block.minecraft.spruce_sapling": "саженец ели",
  "block.minecraft.birch_sapling": "саженец берёзы",
  "block.minecraft.jungle_sapling": "саженец тропического дерева",
  "block.minecraft.acacia_sapling": "саженец акации",
  "block.minecraft.dark_oak_sapling": "саженец тёмного дуба",
  "block.minecraft.bedrock": "бедрок",
  "block.minecraft.sand": "песок",
  "block.minecraft.red_sand": "красный песок",
  "block.minecraft.gravel": "гравий",
  "block.minecraft.gold_ore": "золотая руда",
  "block.minecraft.iron_ore": "железная руда",
  "block.minecraft.coal_ore": "угольная руда",
  "block.minecraft.nether_gold_ore": "незерская золотая руда",
  "block.minecraft.oak_log": "дубовое бревно",
  "block.minecraft.spruce_log": "еловое бревно",
  "block.minecraft.birch_log": "берёзовое бревно",
  "block.minecraft.jungle_log": "бревно тропического дерева",
  "block.minecraft.acacia_log": "акациевое бревно",
  "block.minecraft.dark_oak_log": "бревно тёмного дуба",
  "block.minecraft.crimson_stem": "багровый стебель",
  "block.minecraft.warped_stem": "искажённый стебель",
  "block.minecraft.stripped_oak_log": "обтёсанное дубовое бревно",
  "block.minecraft.stripped_spruce_log": "обтёсанное еловое бревно",
  "block.minecraft.stripped_birch_log": "обтёсанное берёзовое бревно",
  "block.minecraft.stripped_jungle_log": "обтёсанное бревно тропического дерева",
  "block.minecraft.stripped_acacia_log": "обтёсанное акациевое бревно",
  "block.minecraft.stripped_dark_oak_log": "обтёсанное бревно тёмного дуба",
  "block.minecraft.stripped_crimson_stem": "очищенный багровый стебель",
  "block.minecraft.stripped_warped_stem": "очищенный искажённый стебель",
  "block.minecraft.stripped_oak_wood": "обтёсанная дубовая древесина",
  "block.minecraft.stripped_spruce_wood": "обтёсанная еловая древесина",
  "block.minecraft.stripped_birch_wood": "обтёсанная берёзовая древесина",
  "block.minecraft.stripped_jungle_wood": "обтёсанная тропическая древесина",
  "block.minecraft.stripped_acacia_wood": "обтёсанная акациевая древесина",
  "block.minecraft.stripped_dark_oak_wood": "обтёсанная древесина тёмного дуба",
  "block.minecraft.stripped_crimson_hyphae": "очищенные багровые гифы",
  "block.minecraft.stripped_warped_hyphae": "очищенные искажённые гифы",
  "block.minecraft.oak_wood": "дуб",
  "block.minecraft.spruce_wood": "ель",
  "block.minecraft.birch_wood": "берёза",
  "block.minecraft.jungle_wood": "тропическое дерево",
  "block.minecraft.acacia_wood": "акация",
  "block.minecraft.dark_oak_wood": "тёмный дуб",
  "block.minecraft.crimson_hyphae": "багровые гифы",
  "block.minecraft.warped_hyphae": "искажённые гифы",
  "block.minecraft.oak_leaves": "дубовые листья",
  "block.minecraft.spruce_leaves": "хвоя",
  "block.minecraft.birch_leaves": "берёзовые листья",
  "block.minecraft.jungle_leaves": "листья тропического дерева",
  "block.minecraft.acacia_leaves": "листья акации",
  "block.minecraft.dark_oak_leaves": "листья тёмного дуба",
  "block.minecraft.sponge": "губка",
  "block.minecraft.wet_sponge": "мокрая губка",
  "block.minecraft.glass": "стекло",
  "block.minecraft.lapis_ore": "лазуритовая руда",
  "block.minecraft.lapis_block": "лазуритовый блок",
  "block.minecraft.dispenser": "раздатчик",
  "block.minecraft.sandstone": "песчаник",
  "block.minecraft.chiseled_sandstone": "резной песчаник",
  "block.minecraft.cut_sandstone": "пиленый песчаник",
  "block.minecraft.note_block": "нотный блок",
  "block.minecraft.powered_rail": "энергорельсы",
  "block.minecraft.detector_rail": "рельсы с датчиком",
  "block.minecraft.sticky_piston": "липкий поршень",
  "block.minecraft.cobweb": "паутина",
  "block.minecraft.grass": "трава",
  "block.minecraft.fern": "папоротник",
  "block.minecraft.dead_bush": "мёртвый куст",
  "block.minecraft.seagrass": "морская трава",
  "block.minecraft.sea_pickle": "морской огурец",
  "block.minecraft.piston": "поршень",
  "block.minecraft.white_wool": "белая шерсть",
  "block.minecraft.orange_wool": "оранжевая шерсть",
  "block.minecraft.magenta_wool": "пурпурная шерсть",
  "block.minecraft.light_blue_wool": "голубая шерсть",
  "block.minecraft.yellow_wool": "жёлтая шерсть",
  "block.minecraft.lime_wool": "лаймовая шерсть",
  "block.minecraft.pink_wool": "розовая шерсть",
  "block.minecraft.gray_wool": "серая шерсть",
  "block.minecraft.light_gray_wool": "светло-серая шерсть",
  "block.minecraft.cyan_wool": "бирюзовая шерсть",
  "block.minecraft.purple_wool": "фиолетовая шерсть",
  "block.minecraft.blue_wool": "синяя шерсть",
  "block.minecraft.brown_wool": "коричневая шерсть",
  "block.minecraft.green_wool": "зелёная шерсть",
  "block.minecraft.red_wool": "красная шерсть",
  "block.minecraft.black_wool": "чёрная шерсть",
  "block.minecraft.dandelion": "одуванчик",
  "block.minecraft.poppy": "мак",
  "block.minecraft.blue_orchid": "синяя орхидея",
  "block.minecraft.allium": "лук-батун",
  "block.minecraft.azure_bluet": "хаустония серая",
  "block.minecraft.red_tulip": "красный тюльпан",
  "block.minecraft.orange_tulip": "оранжевый тюльпан",
  "block.minecraft.white_tulip": "белый тюльпан",
  "block.minecraft.pink_tulip": "розовый тюльпан",
  "block.minecraft.oxeye_daisy": "ромашка",
  "block.minecraft.cornflower": "синий василёк",
  "block.minecraft.lily_of_the_valley": "ландыш",
  "block.minecraft.wither_rose": "роза визера",
  "block.minecraft.brown_mushroom": "коричневый гриб",
  "block.minecraft.red_mushroom": "красный гриб",
  "block.minecraft.crimson_fungus": "багровый гриб",
  "block.minecraft.warped_fungus": "искажённый гриб",
  "block.minecraft.crimson_roots": "багровые корни",
  "block.minecraft.warped_roots": "искажённые корни",
  "block.minecraft.nether_sprouts": "незерские ростки",
  "block.minecraft.weeping_vines": "плакучая лоза",
  "block.minecraft.twisting_vines": "вьющаяся лоза",
  "block.minecraft.sugar_cane": "сахарный тростник",
  "block.minecraft.kelp": "ламинария",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "золотой блок",
  "block.minecraft.iron_block": "железный блок",
  "block.minecraft.oak_slab": "дубовая плита",
  "block.minecraft.spruce_slab": "еловая плита",
  "block.minecraft.birch_slab": "берёзовая плита",
  "block.minecraft.jungle_slab": "плита из тропического дерева",
  "block.minecraft.acacia_slab": "акациевая плита",
  "block.minecraft.dark_oak_slab": "плита из тёмного дуба",
  "block.minecraft.crimson_slab": "багровая плита",
  "block.minecraft.warped_slab": "искажённая плита",
  "block.minecraft.stone_slab": "каменная плита",
  "block.minecraft.smooth_stone_slab": "плита из гладкого камня",
  "block.minecraft.sandstone_slab": "песчаниковая плита",
  "block.minecraft.cut_sandstone_slab": "плита из пиленого песчаника",
  "block.minecraft.petrified_oak_slab": "окаменевшая дубовая плита",
  "block.minecraft.cobblestone_slab": "булыжная плита",
  "block.minecraft.brick_slab": "кирпичная плита",
  "block.minecraft.stone_brick_slab": "плита из каменного кирпича",
  "block.minecraft.nether_brick_slab": "незерская плита",
  "block.minecraft.quartz_slab": "кварцевая плита",
  "block.minecraft.red_sandstone_slab": "плита из красного песчаника",
  "block.minecraft.cut_red_sandstone_slab": "плита из пиленого красного песчаника",
  "block.minecraft.purpur_slab": "пурпуровая плита",
  "block.minecraft.prismarine_slab": "призмариновая плита",
  "block.minecraft.prismarine_brick_slab": "плита из призмаринового кирпича",
  "block.minecraft.dark_prismarine_slab": "плита из тёмного призмарина",
  "block.minecraft.smooth_quartz": "гладкий кварц",
  "block.minecraft.smooth_red_sandstone": "гладкий красный песчаник",
  "block.minecraft.smooth_sandstone": "гладкий песчаник",
  "block.minecraft.smooth_stone": "гладкий камень",
  "block.minecraft.bricks": "кирпичи",
  "block.minecraft.tnt": "динамит",
  "block.minecraft.bookshelf": "книжная полка",
  "block.minecraft.mossy_cobblestone": "замшелый булыжник",
  "block.minecraft.obsidian": "обсидиан",
  "block.minecraft.torch": "факел",
  "block.minecraft.end_rod": "стержень энда",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "цветок хоруса",
  "block.minecraft.purpur_block": "пурпур",
  "block.minecraft.purpur_pillar": "пурпуровый пилон",
  "block.minecraft.purpur_stairs": "пурпуровые ступеньки",
  "block.minecraft.spawner": "рассадник",
  "block.minecraft.oak_stairs": "дубовые ступеньки",
  "block.minecraft.chest": "сундук",
  "block.minecraft.diamond_ore": "алмазная руда",
  "block.minecraft.diamond_block": "алмазный блок",
  "block.minecraft.crafting_table": "верстак",
  "block.minecraft.farmland": "пашня",
  "block.minecraft.furnace": "печь",
  "block.minecraft.ladder": "лестница",
  "block.minecraft.rail": "рельсы",
  "block.minecraft.cobblestone_stairs": "булыжные ступеньки",
  "block.minecraft.lever": "рычаг",
  "block.minecraft.stone_pressure_plate": "каменная нажимная плита",
  "block.minecraft.oak_pressure_plate": "дубовая нажимная плита",
  "block.minecraft.spruce_pressure_plate": "еловая нажимная плита",
  "block.minecraft.birch_pressure_plate": "берёзовая нажимная плита",
  "block.minecraft.jungle_pressure_plate": "нажимная плита из тропического дерева",
  "block.minecraft.acacia_pressure_plate": "акациевая нажимная плита",
  "block.minecraft.dark_oak_pressure_plate": "нажимная плита из тёмного дуба",
  "block.minecraft.crimson_pressure_plate": "багровая нажимная плита",
  "block.minecraft.warped_pressure_plate": "искажённая нажимная плита",
  "block.minecraft.polished_blackstone_pressure_plate": "нажимная плита из полированного чернита",
  "block.minecraft.redstone_ore": "редстоуновая руда",
  "block.minecraft.redstone_torch": "редстоуновый факел",
  "block.minecraft.snow": "снег",
  "block.minecraft.ice": "лёд",
  "block.minecraft.snow_block": "блок снега",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "глина",
  "block.minecraft.jukebox": "проигрыватель",
  "block.minecraft.oak_fence": "дубовый забор",
  "block.minecraft.spruce_fence": "еловый забор",
  "block.minecraft.birch_fence": "берёзовый забор",
  "block.minecraft.jungle_fence": "забор из тропического дерева",
  "block.minecraft.acacia_fence": "акациевый забор",
  "block.minecraft.dark_oak_fence": "забор из тёмного дуба",
  "block.minecraft.crimson_fence": "багровый забор",
  "block.minecraft.warped_fence": "искажённый забор",
  "block.minecraft.pumpkin": "тыква",
  "block.minecraft.carved_pumpkin": "вырезанная тыква",
  "block.minecraft.netherrack": "незерак",
  "block.minecraft.soul_sand": "песок душ",
  "block.minecraft.soul_soil": "почва душ",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "полированный базальт",
  "block.minecraft.soul_torch": "факел душ",
  "block.minecraft.glowstone": "светокамень",
  "block.minecraft.jack_o_lantern": "светильник джека",
  "block.minecraft.oak_trapdoor": "дубовый люк",
  "block.minecraft.spruce_trapdoor": "еловый люк",
  "block.minecraft.birch_trapdoor": "берёзовый люк",
  "block.minecraft.jungle_trapdoor": "люк из тропического дерева",
  "block.minecraft.acacia_trapdoor": "акациевый люк",
  "block.minecraft.dark_oak_trapdoor": "люк из тёмного дуба",
  "block.minecraft.crimson_trapdoor": "багровый люк",
  "block.minecraft.warped_trapdoor": "искажённый люк",
  "block.minecraft.infested_stone": "заражённый камень",
  "block.minecraft.infested_cobblestone": "заражённый булыжник",
  "block.minecraft.infested_stone_bricks": "заражённые каменные кирпичи",
  "block.minecraft.infested_mossy_stone_bricks": "заражённые замшелые каменные кирпичи",
  "block.minecraft.infested_cracked_stone_bricks": "заражённые потрескавшиеся каменные кирпичи",
  "block.minecraft.infested_chiseled_stone_bricks": "заражённые резные каменные кирпичи",
  "block.minecraft.stone_bricks": "каменные кирпичи",
  "block.minecraft.mossy_stone_bricks": "замшелые каменные кирпичи",
  "block.minecraft.cracked_stone_bricks": "потрескавшиеся каменные кирпичи",
  "block.minecraft.chiseled_stone_bricks": "резные каменные кирпичи",
  "block.minecraft.brown_mushroom_block": "блок коричневого гриба",
  "block.minecraft.red_mushroom_block": "блок красного гриба",
  "block.minecraft.mushroom_stem": "ножка гриба",
  "block.minecraft.iron_bars": "железные прутья",
  "block.minecraft.chain": "цепь",
  "block.minecraft.glass_pane": "стеклянная панель",
  "block.minecraft.melon": "арбуз",
  "block.minecraft.vine": "лианы",
  "block.minecraft.oak_fence_gate": "дубовая калитка",
  "block.minecraft.spruce_fence_gate": "еловая калитка",
  "block.minecraft.birch_fence_gate": "берёзовая калитка",
  "block.minecraft.jungle_fence_gate": "калитка из тропического дерева",
  "block.minecraft.acacia_fence_gate": "акациевая калитка",
  "block.minecraft.dark_oak_fence_gate": "калитка из тёмного дуба",
  "block.minecraft.crimson_fence_gate": "багровая калитка",
  "block.minecraft.warped_fence_gate": "искажённая калитка",
  "block.minecraft.brick_stairs": "кирпичные ступеньки",
  "block.minecraft.stone_brick_stairs": "ступеньки из каменного кирпича",
  "block.minecraft.mycelium": "мицелий",
  "block.minecraft.lily_pad": "кувшинка",
  "block.minecraft.nether_bricks": "незерские кирпичи",
  "block.minecraft.cracked_nether_bricks": "потрескавшиеся незерские кирпичи",
  "block.minecraft.chiseled_nether_bricks": "резные незерские кирпичи",
  "block.minecraft.nether_brick_fence": "незерский забор",
  "block.minecraft.nether_brick_stairs": "незерские ступеньки",
  "block.minecraft.enchanting_table": "чародейский стол",
  "block.minecraft.end_portal_frame": "рамка портала в энд",
  "block.minecraft.end_stone": "эндерняк",
  "block.minecraft.end_stone_bricks": "эндерняковые кирпичи",
  "block.minecraft.dragon_egg": "яйцо дракона",
  "block.minecraft.redstone_lamp": "редстоуновый фонарь",
  "block.minecraft.sandstone_stairs": "песчаниковые ступеньки",
  "block.minecraft.emerald_ore": "изумрудная руда",
  "block.minecraft.ender_chest": "эндер-сундук",
  "block.minecraft.tripwire_hook": "крюк",
  "block.minecraft.emerald_block": "изумрудный блок",
  "block.minecraft.spruce_stairs": "еловые ступеньки",
  "block.minecraft.birch_stairs": "берёзовые ступеньки",
  "block.minecraft.jungle_stairs": "ступеньки из тропического дерева",
  "block.minecraft.crimson_stairs": "багровые ступеньки",
  "block.minecraft.warped_stairs": "искажённые ступеньки",
  "block.minecraft.command_block": "командный блок",
  "block.minecraft.beacon": "маяк",
  "block.minecraft.cobblestone_wall": "булыжная ограда",
  "block.minecraft.mossy_cobblestone_wall": "замшелая булыжная ограда",
  "block.minecraft.brick_wall": "кирпичная ограда",
  "block.minecraft.prismarine_wall": "призмариновая ограда",
  "block.minecraft.red_sandstone_wall": "ограда из красного песчаника",
  "block.minecraft.mossy_stone_brick_wall": "ограда из замшелого каменного кирпича",
  "block.minecraft.granite_wall": "гранитная ограда",
  "block.minecraft.stone_brick_wall": "ограда из каменного кирпича",
  "block.minecraft.nether_brick_wall": "ограда из незерского кирпича",
  "block.minecraft.andesite_wall": "андезитовая ограда",
  "block.minecraft.red_nether_brick_wall": "ограда из красного незерского кирпича",
  "block.minecraft.sandstone_wall": "песчаниковая ограда",
  "block.minecraft.end_stone_brick_wall": "ограда из эндернякового кирпича",
  "block.minecraft.diorite_wall": "диоритовая ограда",
  "block.minecraft.blackstone_wall": "чернитная ограда",
  "block.minecraft.polished_blackstone_wall": "ограда из полированного чернита",
  "block.minecraft.polished_blackstone_brick_wall": "ограда из полированно-чернитного кирпича",
  "block.minecraft.stone_button": "каменная кнопка",
  "block.minecraft.oak_button": "дубовая кнопка",
  "block.minecraft.spruce_button": "еловая кнопка",
  "block.minecraft.birch_button": "берёзовая кнопка",
  "block.minecraft.jungle_button": "кнопка из тропического дерева",
  "block.minecraft.acacia_button": "акациевая кнопка",
  "block.minecraft.dark_oak_button": "кнопка из тёмного дуба",
  "block.minecraft.crimson_button": "багровая кнопка",
  "block.minecraft.warped_button": "искажённая кнопка",
  "block.minecraft.polished_blackstone_button": "кнопка из полированного чернита",
  "block.minecraft.anvil": "наковальня",
  "block.minecraft.chipped_anvil": "повреждённая наковальня",
  "block.minecraft.damaged_anvil": "разбитая наковальня",
  "block.minecraft.trapped_chest": "сундук-ловушка",
  "block.minecraft.light_weighted_pressure_plate": "весовая пластина",
  "block.minecraft.heavy_weighted_pressure_plate": "большегрузная весовая пластина",
  "block.minecraft.daylight_detector": "датчик дневного света",
  "block.minecraft.redstone_block": "редстоуновый блок",
  "block.minecraft.nether_quartz_ore": "незер-кварцевая руда",
  "block.minecraft.hopper": "воронка",
  "block.minecraft.chiseled_quartz_block": "резной кварцевый блок",
  "block.minecraft.quartz_block": "кварцевый блок",
  "block.minecraft.quartz_bricks": "кварцевые кирпичи",
  "block.minecraft.quartz_pillar": "кварцевая колонна",
  "block.minecraft.quartz_stairs": "кварцевые ступеньки",
  "block.minecraft.activator_rail": "активирующие рельсы",
  "block.minecraft.dropper": "выбрасыватель",
  "block.minecraft.white_terracotta": "белая керамика",
  "block.minecraft.orange_terracotta": "оранжевая керамика",
  "block.minecraft.magenta_terracotta": "пурпурная керамика",
  "block.minecraft.light_blue_terracotta": "голубая керамика",
  "block.minecraft.yellow_terracotta": "жёлтая керамика",
  "block.minecraft.lime_terracotta": "лаймовая керамика",
  "block.minecraft.pink_terracotta": "розовая керамика",
  "block.minecraft.gray_terracotta": "серая керамика",
  "block.minecraft.light_gray_terracotta": "светло-серая керамика",
  "block.minecraft.cyan_terracotta": "бирюзовая керамика",
  "block.minecraft.purple_terracotta": "фиолетовая керамика",
  "block.minecraft.blue_terracotta": "синяя керамика",
  "block.minecraft.brown_terracotta": "коричневая керамика",
  "block.minecraft.green_terracotta": "зелёная керамика",
  "block.minecraft.red_terracotta": "красная керамика",
  "block.minecraft.black_terracotta": "чёрная керамика",
  "block.minecraft.barrier": "барьер",
  "block.minecraft.iron_trapdoor": "железный люк",
  "block.minecraft.hay_block": "сноп сена",
  "block.minecraft.white_carpet": "белый ковёр",
  "block.minecraft.orange_carpet": "оранжевый ковёр",
  "block.minecraft.magenta_carpet": "пурпурный ковёр",
  "block.minecraft.light_blue_carpet": "голубой ковёр",
  "block.minecraft.yellow_carpet": "жёлтый ковёр",
  "block.minecraft.lime_carpet": "лаймовый ковёр",
  "block.minecraft.pink_carpet": "розовый ковёр",
  "block.minecraft.gray_carpet": "серый ковёр",
  "block.minecraft.light_gray_carpet": "светло-серый ковёр",
  "block.minecraft.cyan_carpet": "бирюзовый ковёр",
  "block.minecraft.purple_carpet": "фиолетовый ковёр",
  "block.minecraft.blue_carpet": "синий ковёр",
  "block.minecraft.brown_carpet": "коричневый ковёр",
  "block.minecraft.green_carpet": "зелёный ковёр",
  "block.minecraft.red_carpet": "красный ковёр",
  "block.minecraft.black_carpet": "чёрный ковёр",
  "block.minecraft.terracotta": "терракота",
  "block.minecraft.coal_block": "угольный блок",
  "block.minecraft.packed_ice": "плотный лёд",
  "block.minecraft.acacia_stairs": "акациевые ступеньки",
  "block.minecraft.dark_oak_stairs": "ступеньки из тёмного дуба",
  "block.minecraft.slime_block": "блок слизи",
  "block.minecraft.grass_path": "тропа",
  "block.minecraft.sunflower": "подсолнух",
  "block.minecraft.lilac": "сирень",
  "block.minecraft.rose_bush": "розовый куст",
  "block.minecraft.peony": "пион",
  "block.minecraft.tall_grass": "высокая трава",
  "block.minecraft.large_fern": "раскидистый папоротник",
  "block.minecraft.white_stained_glass": "белое стекло",
  "block.minecraft.orange_stained_glass": "оранжевое стекло",
  "block.minecraft.magenta_stained_glass": "пурпурное стекло",
  "block.minecraft.light_blue_stained_glass": "голубое стекло",
  "block.minecraft.yellow_stained_glass": "жёлтое стекло",
  "block.minecraft.lime_stained_glass": "лаймовое стекло",
  "block.minecraft.pink_stained_glass": "розовое стекло",
  "block.minecraft.gray_stained_glass": "серое стекло",
  "block.minecraft.light_gray_stained_glass": "светло-серое стекло",
  "block.minecraft.cyan_stained_glass": "бирюзовое стекло",
  "block.minecraft.purple_stained_glass": "фиолетовое стекло",
  "block.minecraft.blue_stained_glass": "синее стекло",
  "block.minecraft.brown_stained_glass": "коричневое стекло",
  "block.minecraft.green_stained_glass": "зелёное стекло",
  "block.minecraft.red_stained_glass": "красное стекло",
  "block.minecraft.black_stained_glass": "чёрное стекло",
  "block.minecraft.white_stained_glass_pane": "белая стеклянная панель",
  "block.minecraft.orange_stained_glass_pane": "оранжевая стеклянная панель",
  "block.minecraft.magenta_stained_glass_pane": "пурпурная стеклянная панель",
  "block.minecraft.light_blue_stained_glass_pane": "голубая стеклянная панель",
  "block.minecraft.yellow_stained_glass_pane": "жёлтая стеклянная панель",
  "block.minecraft.lime_stained_glass_pane": "лаймовая стеклянная панель",
  "block.minecraft.pink_stained_glass_pane": "розовая стеклянная панель",
  "block.minecraft.gray_stained_glass_pane": "серая стеклянная панель",
  "block.minecraft.light_gray_stained_glass_pane": "светло-серая стеклянная панель",
  "block.minecraft.cyan_stained_glass_pane": "бирюзовая стеклянная панель",
  "block.minecraft.purple_stained_glass_pane": "фиолетовая стеклянная панель",
  "block.minecraft.blue_stained_glass_pane": "синяя стеклянная панель",
  "block.minecraft.brown_stained_glass_pane": "коричневая стеклянная панель",
  "block.minecraft.green_stained_glass_pane": "зелёная стеклянная панель",
  "block.minecraft.red_stained_glass_pane": "красная стеклянная панель",
  "block.minecraft.black_stained_glass_pane": "чёрная стеклянная панель",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмариновые кирпичи",
  "block.minecraft.dark_prismarine": "тёмный призмарин",
  "block.minecraft.prismarine_stairs": "призмариновые ступеньки",
  "block.minecraft.prismarine_brick_stairs": "ступеньки из призмаринового кирпича",
  "block.minecraft.dark_prismarine_stairs": "ступеньки из тёмного призмарина",
  "block.minecraft.sea_lantern": "морской фонарь",
  "block.minecraft.red_sandstone": "красный песчаник",
  "block.minecraft.chiseled_red_sandstone": "резной красный песчаник",
  "block.minecraft.cut_red_sandstone": "пиленый красный песчаник",
  "block.minecraft.red_sandstone_stairs": "ступеньки из красного песчаника",
  "block.minecraft.repeating_command_block": "повторяющий командный блок",
  "block.minecraft.chain_command_block": "последовательный командный блок",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "блок незерского нароста",
  "block.minecraft.warped_wart_block": "блок искажённого нароста",
  "block.minecraft.red_nether_bricks": "красные незерские кирпичи",
  "block.minecraft.bone_block": "костный блок",
  "block.minecraft.structure_void": "пустой блок",
  "block.minecraft.observer": "наблюдатель",
  "block.minecraft.shulker_box": "шалкеровый ящик",
  "block.minecraft.white_shulker_box": "белый шалкеровый ящик",
  "block.minecraft.orange_shulker_box": "оранжевый шалкеровый ящик",
  "block.minecraft.magenta_shulker_box": "пурпурный шалкеровый ящик",
  "block.minecraft.light_blue_shulker_box": "голубой шалкеровый ящик",
  "block.minecraft.yellow_shulker_box": "жёлтый шалкеровый ящик",
  "block.minecraft.lime_shulker_box": "лаймовый шалкеровый ящик",
  "block.minecraft.pink_shulker_box": "розовый шалкеровый ящик",
  "block.minecraft.gray_shulker_box": "серый шалкеровый ящик",
  "block.minecraft.light_gray_shulker_box": "светло-серый шалкеровый ящик",
  "block.minecraft.cyan_shulker_box": "бирюзовый шалкеровый ящик",
  "block.minecraft.purple_shulker_box": "фиолетовый шалкеровый ящик",
  "block.minecraft.blue_shulker_box": "синий шалкеровый ящик",
  "block.minecraft.brown_shulker_box": "коричневый шалкеровый ящик",
  "block.minecraft.green_shulker_box": "зелёный шалкеровый ящик",
  "block.minecraft.red_shulker_box": "красный шалкеровый ящик",
  "block.minecraft.black_shulker_box": "чёрный шалкеровый ящик",
  "block.minecraft.white_glazed_terracotta": "белая глазурованная керамика",
  "block.minecraft.orange_glazed_terracotta": "оранжевая глазурованная керамика",
  "block.minecraft.magenta_glazed_terracotta": "пурпурная глазурованная керамика",
  "block.minecraft.light_blue_glazed_terracotta": "голубая глазурованная керамика",
  "block.minecraft.yellow_glazed_terracotta": "жёлтая глазурованная керамика",
  "block.minecraft.lime_glazed_terracotta": "лаймовая глазурованная керамика",
  "block.minecraft.pink_glazed_terracotta": "розовая глазурованная керамика",
  "block.minecraft.gray_glazed_terracotta": "серая глазурованная керамика",
  "block.minecraft.light_gray_glazed_terracotta": "светло-серая глазурованная керамика",
  "block.minecraft.cyan_glazed_terracotta": "бирюзовая глазурованная керамика",
  "block.minecraft.purple_glazed_terracotta": "фиолетовая глазурованная керамика",
  "block.minecraft.blue_glazed_terracotta": "синяя глазурованная керамика",
  "block.minecraft.brown_glazed_terracotta": "коричневая глазурованная керамика",
  "block.minecraft.green_glazed_terracotta": "зелёная глазурованная керамика",
  "block.minecraft.red_glazed_terracotta": "красная глазурованная керамика",
  "block.minecraft.black_glazed_terracotta": "чёрная глазурованная керамика",
  "block.minecraft.white_concrete": "белый бетон",
  "block.minecraft.orange_concrete": "оранжевый бетон",
  "block.minecraft.magenta_concrete": "пурпурный бетон",
  "block.minecraft.light_blue_concrete": "голубой бетон",
  "block.minecraft.yellow_concrete": "жёлтый бетон",
  "block.minecraft.lime_concrete": "лаймовый бетон",
  "block.minecraft.pink_concrete": "розовый бетон",
  "block.minecraft.gray_concrete": "серый бетон",
  "block.minecraft.light_gray_concrete": "светло-серый бетон",
  "block.minecraft.cyan_concrete": "бирюзовый бетон",
  "block.minecraft.purple_concrete": "фиолетовый бетон",
  "block.minecraft.blue_concrete": "синий бетон",
  "block.minecraft.brown_concrete": "коричневый бетон",
  "block.minecraft.green_concrete": "зелёный бетон",
  "block.minecraft.red_concrete": "красный бетон",
  "block.minecraft.black_concrete": "чёрный бетон",
  "block.minecraft.white_concrete_powder": "белый сухой бетон",
  "block.minecraft.orange_concrete_powder": "оранжевый сухой бетон",
  "block.minecraft.magenta_concrete_powder": "пурпурный сухой бетон",
  "block.minecraft.light_blue_concrete_powder": "голубой сухой бетон",
  "block.minecraft.yellow_concrete_powder": "жёлтый сухой бетон",
  "block.minecraft.lime_concrete_powder": "лаймовый сухой бетон",
  "block.minecraft.pink_concrete_powder": "розовый сухой бетон",
  "block.minecraft.gray_concrete_powder": "серый сухой бетон",
  "block.minecraft.light_gray_concrete_powder": "светло-серый сухой бетон",
  "block.minecraft.cyan_concrete_powder": "бирюзовый сухой бетон",
  "block.minecraft.purple_concrete_powder": "фиолетовый сухой бетон",
  "block.minecraft.blue_concrete_powder": "синий сухой бетон",
  "block.minecraft.brown_concrete_powder": "коричневый сухой бетон",
  "block.minecraft.green_concrete_powder": "зелёный сухой бетон",
  "block.minecraft.red_concrete_powder": "красный сухой бетон",
  "block.minecraft.black_concrete_powder": "чёрный сухой бетон",
  "block.minecraft.turtle_egg": "черепашье яйцо",
  "block.minecraft.dead_tube_coral_block": "блок мёртвого трубчатого коралла",
  "block.minecraft.dead_brain_coral_block": "блок мёртвого коралла-мозговика",
  "block.minecraft.dead_bubble_coral_block": "блок мёртвого пузырчатого коралла",
  "block.minecraft.dead_fire_coral_block": "блок мёртвого огненного коралла",
  "block.minecraft.dead_horn_coral_block": "блок мёртвого рогового коралла",
  "block.minecraft.tube_coral_block": "блок трубчатого коралла",
  "block.minecraft.brain_coral_block": "блок коралла-мозговика",
  "block.minecraft.bubble_coral_block": "блок пузырчатого коралла",
  "block.minecraft.fire_coral_block": "блок огненного коралла",
  "block.minecraft.horn_coral_block": "блок рогового коралла",
  "block.minecraft.tube_coral": "трубчатый коралл",
  "block.minecraft.brain_coral": "коралл-мозговик",
  "block.minecraft.bubble_coral": "пузырчатый коралл",
  "block.minecraft.fire_coral": "огненный коралл",
  "block.minecraft.horn_coral": "роговой коралл",
  "block.minecraft.dead_brain_coral": "мёртвый коралл-мозговик",
  "block.minecraft.dead_bubble_coral": "мёртвый пузырчатый коралл",
  "block.minecraft.dead_fire_coral": "мёртвый огненный коралл",
  "block.minecraft.dead_horn_coral": "мёртвый роговый коралл",
  "block.minecraft.dead_tube_coral": "мёртвый трубчатый коралл",
  "block.minecraft.tube_coral_fan": "веерный трубчатый коралл",
  "block.minecraft.brain_coral_fan": "веерный коралл-мозговик",
  "block.minecraft.bubble_coral_fan": "веерный пузырчатый коралл",
  "block.minecraft.fire_coral_fan": "веерный огненный коралл",
  "block.minecraft.horn_coral_fan": "веерный роговый коралл",
  "block.minecraft.dead_tube_coral_fan": "мёртвый веерный трубчатый коралл",
  "block.minecraft.dead_brain_coral_fan": "мёртвый веерный коралл-мозговик",
  "block.minecraft.dead_bubble_coral_fan": "мёртвый веерный пузырчатый коралл",
  "block.minecraft.dead_fire_coral_fan": "мёртвый веерный огненный коралл",
  "block.minecraft.dead_horn_coral_fan": "мёртвый веерный роговый коралл",
  "block.minecraft.blue_ice": "синий лёд",
  "block.minecraft.conduit": "морской источник",
  "block.minecraft.polished_granite_stairs": "ступеньки из полированного гранита",
  "block.minecraft.smooth_red_sandstone_stairs": "ступеньки из гладкого красного песчаника",
  "block.minecraft.mossy_stone_brick_stairs": "ступеньки из замшелого каменного кирпича",
  "block.minecraft.polished_diorite_stairs": "ступеньки из полированного диорита",
  "block.minecraft.mossy_cobblestone_stairs": "замшелые булыжные ступеньки",
  "block.minecraft.end_stone_brick_stairs": "ступеньки из эндернякового кирпича",
  "block.minecraft.stone_stairs": "каменные ступеньки",
  "block.minecraft.smooth_sandstone_stairs": "ступеньки из гладкого песчаника",
  "block.minecraft.smooth_quartz_stairs": "ступеньки из гладкого кварца",
  "block.minecraft.granite_stairs": "гранитные ступеньки",
  "block.minecraft.andesite_stairs": "андезитовые ступеньки",
  "block.minecraft.red_nether_brick_stairs": "ступеньки из красного незерского кирпича",
  "block.minecraft.polished_andesite_stairs": "ступеньки из полированного андезита",
  "block.minecraft.diorite_stairs": "диоритовые ступеньки",
  "block.minecraft.polished_granite_slab": "плита из полированного гранита",
  "block.minecraft.smooth_red_sandstone_slab": "плита из гладкого красного песчаника",
  "block.minecraft.mossy_stone_brick_slab": "плита из замшелого каменного кирпича",
  "block.minecraft.polished_diorite_slab": "плита из полированного диорита",
  "block.minecraft.mossy_cobblestone_slab": "замшелая булыжная плита",
  "block.minecraft.end_stone_brick_slab": "плита из эндернякового кирпича",
  "block.minecraft.smooth_sandstone_slab": "плита из гладкого песчаника",
  "block.minecraft.smooth_quartz_slab": "плита из гладкого кварца",
  "block.minecraft.granite_slab": "гранитная плита",
  "block.minecraft.andesite_slab": "андезитовая плита",
  "block.minecraft.red_nether_brick_slab": "плита из красного незерского кирпича",
  "block.minecraft.polished_andesite_slab": "плита из полированного андезита",
  "block.minecraft.diorite_slab": "диоритовая плита",
  "block.minecraft.scaffolding": "подмостки",
  "block.minecraft.iron_door": "железная дверь",
  "block.minecraft.oak_door": "дубовая дверь",
  "block.minecraft.spruce_door": "еловая дверь",
  "block.minecraft.birch_door": "берёзовая дверь",
  "block.minecraft.jungle_door": "дверь из тропического дерева",
  "block.minecraft.acacia_door": "акациевая дверь",
  "block.minecraft.dark_oak_door": "дверь из тёмного дуба",
  "block.minecraft.crimson_door": "багровая дверь",
  "block.minecraft.warped_door": "искажённая дверь",
  "block.minecraft.repeater": "редстоуновый повторитель",
  "block.minecraft.comparator": "редстоуновый компаратор",
  "block.minecraft.structure_block": "блок-конструктор",
  "block.minecraft.jigsaw": "пазл",
  "item.minecraft.turtle_helmet": "черепаший панцирь□□когда надето на голову:□+2 броня",
  "item.minecraft.scute": "щиток",
  "item.minecraft.iron_shovel": "железная лопата□□когда в ведущей руке:□+3.5 урон□-3 скорость атаки",
  "item.minecraft.iron_pickaxe": "железная кирка□□когда в ведущей руке:□+3 урон□-2.8 скорость атаки",
  "item.minecraft.iron_axe": "железный топор□□когда в ведущей руке:□+8 урон□-3.1 скорость атаки",
  "item.minecraft.flint_and_steel": "огниво",
  "item.minecraft.apple": "яблоко",
  "item.minecraft.bow": "лук",
  "item.minecraft.arrow": "стрела",
  "item.minecraft.coal": "уголь",
  "item.minecraft.charcoal": "древесный уголь",
  "item.minecraft.diamond": "алмаз",
  "item.minecraft.iron_ingot": "железный слиток",
  "item.minecraft.gold_ingot": "золотой слиток",
  "item.minecraft.netherite_ingot": "незеритовый слиток",
  "item.minecraft.netherite_scrap": "незеритовый лом",
  "item.minecraft.iron_sword": "железный меч□□когда в ведущей руке:□+5 урон□-2.4 скорость атаки",
  "item.minecraft.wooden_sword": "деревянный меч□□когда в ведущей руке:□+3 урон□-2.4 скорость атаки",
  "item.minecraft.wooden_shovel": "деревянная лопата□□когда в ведущей руке:□+1.5 урон□-3 скорость атаки",
  "item.minecraft.wooden_pickaxe": "деревянная кирка□□когда в ведущей руке:□+1 урон□-2.8 скорость атаки",
  "item.minecraft.wooden_axe": "деревянный топор□□когда в ведущей руке:□+6 урон□-3.2 скорость атаки",
  "item.minecraft.stone_sword": "каменный меч□□когда в ведущей руке:□+4 урон□-2.4 скорость атаки",
  "item.minecraft.stone_shovel": "каменная лопата□□когда в ведущей руке:□+2.5 урон□-3 скорость атаки",
  "item.minecraft.stone_pickaxe": "каменная кирка□□когда в ведущей руке:□+2 урон□-2.8 скорость атаки",
  "item.minecraft.stone_axe": "каменный топор□□когда в ведущей руке:□+8 урон□-3.2 скорость атаки",
  "item.minecraft.diamond_sword": "алмазный меч□□когда в ведущей руке:□+6 урон□-2.4 скорость атаки",
  "item.minecraft.diamond_shovel": "алмазная лопата□□когда в ведущей руке:□+4.5 урон□-3 скорость атаки",
  "item.minecraft.diamond_pickaxe": "алмазная кирка□□когда в ведущей руке:□+4 урон□-2.8 скорость атаки",
  "item.minecraft.diamond_axe": "алмазный топор□□когда в ведущей руке:□+8 урон□-3 скорость атаки",
  "item.minecraft.stick": "палка",
  "item.minecraft.bowl": "миска",
  "item.minecraft.mushroom_stew": "тушёные грибы",
  "item.minecraft.golden_sword": "золотой меч□□когда в ведущей руке:□+3 урон□-2.4 скорость атаки",
  "item.minecraft.golden_shovel": "золотая лопата□□когда в ведущей руке:□+1.5 урон□-3 скорость атаки",
  "item.minecraft.golden_pickaxe": "золотая кирка□□когда в ведущей руке:□+1 урон□-2.8 скорость атаки",
  "item.minecraft.golden_axe": "золотой топор□□когда в ведущей руке:□+6 урон□-3 скорость атаки",
  "item.minecraft.netherite_sword": "незеритовый меч□□когда в ведущей руке:□+7 урон□-2.4 скорость атаки",
  "item.minecraft.netherite_shovel": "незеритовая лопата□□когда в ведущей руке:□+5.5 урон□-3 скорость атаки",
  "item.minecraft.netherite_pickaxe": "незеритовая кирка□□когда в ведущей руке:□+5 урон□-2.8 скорость атаки",
  "item.minecraft.netherite_axe": "незеритовый топор□□когда в ведущей руке:□+9 урон□-3 скорость атаки",
  "item.minecraft.string": "нить",
  "item.minecraft.feather": "перо",
  "item.minecraft.gunpowder": "порох",
  "item.minecraft.wooden_hoe": "деревянная мотыга□□когда в ведущей руке:□-3 скорость атаки",
  "item.minecraft.stone_hoe": "каменная мотыга□□когда в ведущей руке:□-2 скорость атаки",
  "item.minecraft.iron_hoe": "железная мотыга□□когда в ведущей руке:□-1 скорость атаки",
  "item.minecraft.diamond_hoe": "алмазная мотыга□□когда в ведущей руке:",
  "item.minecraft.golden_hoe": "золотая мотыга□□когда в ведущей руке:□-3 скорость атаки",
  "item.minecraft.netherite_hoe": "незеритовая мотыга□□когда в ведущей руке:",
  "item.minecraft.wheat_seeds": "семена пшеницы",
  "item.minecraft.wheat": "пшеница",
  "item.minecraft.bread": "хлеб",
  "item.minecraft.leather_helmet": "кожаный шлем□□когда надето на голову:□+1 броня",
  "item.minecraft.leather_chestplate": "кожаная куртка□□когда надето:□+3 броня",
  "item.minecraft.leather_leggings": "кожаные штаны□□когда надето на ноги:□+2 броня",
  "item.minecraft.leather_boots": "кожаные ботинки□□когда обуто:□+1 броня",
  "item.minecraft.chainmail_helmet": "койф□□когда надето на голову:□+2 броня",
  "item.minecraft.chainmail_chestplate": "кольчуга□□когда надето:□+5 броня",
  "item.minecraft.chainmail_leggings": "кольчужные поножи□□когда надето на ноги:□+4 броня",
  "item.minecraft.chainmail_boots": "кольчужные ботинки□□когда обуто:□+1 броня",
  "item.minecraft.iron_helmet": "железный шлем□□когда надето на голову:□+2 броня",
  "item.minecraft.iron_chestplate": "железный нагрудник□□когда надето:□+6 броня",
  "item.minecraft.iron_leggings": "железные поножи□□когда надето на ноги:□+5 броня",
  "item.minecraft.iron_boots": "железные ботинки□□когда обуто:□+2 броня",
  "item.minecraft.diamond_helmet": "алмазный шлем□□когда надето на голову:□+3 броня□+2 твёрдость брони",
  "item.minecraft.diamond_chestplate": "алмазный нагрудник□□когда надето:□+8 броня□+2 твёрдость брони",
  "item.minecraft.diamond_leggings": "алмазные поножи□□когда надето на ноги:□+6 броня□+2 твёрдость брони",
  "item.minecraft.diamond_boots": "алмазные ботинки□□когда обуто:□+3 броня□+2 твёрдость брони",
  "item.minecraft.golden_helmet": "золотой шлем□□когда надето на голову:□+2 броня",
  "item.minecraft.golden_chestplate": "золотой нагрудник□□когда надето:□+5 броня",
  "item.minecraft.golden_leggings": "золотые поножи□□когда надето на ноги:□+3 броня",
  "item.minecraft.golden_boots": "золотые ботинки□□когда обуто:□+1 броня",
  "item.minecraft.netherite_helmet": "незеритовый шлем□□когда надето на голову:□+3 броня□+3 твёрдость брони□+1 сопротивление отбрасыванию",
  "item.minecraft.netherite_chestplate": "незеритовый нагрудник□□когда надето:□+8 броня□+3 твёрдость брони□+1 сопротивление отбрасыванию",
  "item.minecraft.netherite_leggings": "незеритовые поножи□□когда надето на ноги:□+6 броня□+3 твёрдость брони□+1 сопротивление отбрасыванию",
  "item.minecraft.netherite_boots": "незеритовые ботинки□□когда обуто:□+3 броня□+3 твёрдость брони□+1 сопротивление отбрасыванию",
  "item.minecraft.flint": "кремень",
  "item.minecraft.porkchop": "сырая свинина",
  "item.minecraft.cooked_porkchop": "жареная свинина",
  "item.minecraft.painting": "картина",
  "item.minecraft.golden_apple": "золотое яблоко",
  "item.minecraft.enchanted_golden_apple": "зачарованное золотое яблоко",
  "block.minecraft.oak_sign": "дубовая табличка",
  "block.minecraft.spruce_sign": "еловая табличка",
  "block.minecraft.birch_sign": "берёзовая табличка",
  "block.minecraft.jungle_sign": "табличка из тропического дерева",
  "block.minecraft.acacia_sign": "акациевая табличка",
  "block.minecraft.dark_oak_sign": "табличка из тёмного дуба",
  "block.minecraft.crimson_sign": "багровая табличка",
  "block.minecraft.warped_sign": "искажённая табличка",
  "item.minecraft.bucket": "ведро",
  "item.minecraft.water_bucket": "ведро воды",
  "item.minecraft.lava_bucket": "ведро лавы",
  "item.minecraft.minecart": "вагонетка",
  "item.minecraft.saddle": "седло",
  "item.minecraft.redstone": "редстоуновая пыль",
  "item.minecraft.snowball": "снежок",
  "item.minecraft.oak_boat": "дубовая лодка",
  "item.minecraft.leather": "кожа",
  "item.minecraft.milk_bucket": "ведро молока",
  "item.minecraft.pufferfish_bucket": "иглобрюх в ведре",
  "item.minecraft.salmon_bucket": "лосось в ведре",
  "item.minecraft.cod_bucket": "треска в ведре",
  "item.minecraft.tropical_fish_bucket": "тропическая рыба в ведре",
  "item.minecraft.brick": "кирпич",
  "item.minecraft.clay_ball": "комок глины",
  "block.minecraft.dried_kelp_block": "блок сушёной ламинарии",
  "item.minecraft.paper": "бумага",
  "item.minecraft.book": "книга",
  "item.minecraft.slime_ball": "сгусток слизи",
  "item.minecraft.chest_minecart": "грузовая вагонетка",
  "item.minecraft.furnace_minecart": "самоходная вагонетка",
  "item.minecraft.egg": "яйцо",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "удочка",
  "item.minecraft.clock": "часы",
  "item.minecraft.glowstone_dust": "светокаменная пыль",
  "item.minecraft.cod": "сырая треска",
  "item.minecraft.salmon": "сырой лосось",
  "item.minecraft.tropical_fish": "тропическая рыба",
  "item.minecraft.pufferfish": "иглобрюх",
  "item.minecraft.cooked_cod": "жареная треска",
  "item.minecraft.cooked_salmon": "жареный лосось",
  "item.minecraft.ink_sac": "чернильный мешок",
  "item.minecraft.red_dye": "красный краситель",
  "item.minecraft.green_dye": "зелёный краситель",
  "item.minecraft.cocoa_beans": "какао-бобы",
  "item.minecraft.lapis_lazuli": "лазурит",
  "item.minecraft.purple_dye": "фиолетовый краситель",
  "item.minecraft.cyan_dye": "бирюзовый краситель",
  "item.minecraft.light_gray_dye": "светло-серый краситель",
  "item.minecraft.gray_dye": "серый краситель",
  "item.minecraft.pink_dye": "розовый краситель",
  "item.minecraft.lime_dye": "лаймовый краситель",
  "item.minecraft.yellow_dye": "жёлтый краситель",
  "item.minecraft.light_blue_dye": "голубой краситель",
  "item.minecraft.magenta_dye": "пурпурный краситель",
  "item.minecraft.orange_dye": "оранжевый краситель",
  "item.minecraft.bone_meal": "костная мука",
  "item.minecraft.blue_dye": "синий краситель",
  "item.minecraft.brown_dye": "коричневый краситель",
  "item.minecraft.black_dye": "чёрный краситель",
  "item.minecraft.white_dye": "белый краситель",
  "item.minecraft.bone": "кость",
  "item.minecraft.sugar": "сахар",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "белая кровать",
  "block.minecraft.orange_bed": "оранжевая кровать",
  "block.minecraft.magenta_bed": "пурпурная кровать",
  "block.minecraft.light_blue_bed": "голубая кровать",
  "block.minecraft.yellow_bed": "жёлтая кровать",
  "block.minecraft.lime_bed": "лаймовая кровать",
  "block.minecraft.pink_bed": "розовая кровать",
  "block.minecraft.gray_bed": "серая кровать",
  "block.minecraft.light_gray_bed": "светло-серая кровать",
  "block.minecraft.cyan_bed": "бирюзовая кровать",
  "block.minecraft.purple_bed": "фиолетовая кровать",
  "block.minecraft.blue_bed": "синяя кровать",
  "block.minecraft.brown_bed": "коричневая кровать",
  "block.minecraft.green_bed": "зелёная кровать",
  "block.minecraft.red_bed": "красная кровать",
  "block.minecraft.black_bed": "чёрная кровать",
  "item.minecraft.cookie": "печенье",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "ножницы",
  "item.minecraft.melon_slice": "ломтик арбуза",
  "item.minecraft.dried_kelp": "сушёная ламинария",
  "item.minecraft.pumpkin_seeds": "семена тыквы",
  "item.minecraft.melon_seeds": "семена арбуза",
  "item.minecraft.beef": "сырая говядина",
  "item.minecraft.cooked_beef": "стейк",
  "item.minecraft.chicken": "курятина",
  "item.minecraft.cooked_chicken": "жареная курица",
  "item.minecraft.rotten_flesh": "гнилая плоть",
  "item.minecraft.ender_pearl": "эндер-жемчуг",
  "item.minecraft.blaze_rod": "огненный стержень",
  "item.minecraft.ghast_tear": "слеза гаста",
  "item.minecraft.gold_nugget": "кусочек золота",
  "item.minecraft.nether_wart": "незерский нарост",
  "item.minecraft.potion": "несоздаваемое зелье□без эффектов",
  "item.minecraft.glass_bottle": "бутылочка",
  "item.minecraft.spider_eye": "паучий глаз",
  "item.minecraft.fermented_spider_eye": "маринованный паучий глаз",
  "item.minecraft.blaze_powder": "огненный порошок",
  "item.minecraft.magma_cream": "сгусток магмы",
  "block.minecraft.brewing_stand": "зельеварка",
  "block.minecraft.cauldron": "котёл",
  "item.minecraft.ender_eye": "око эндера",
  "item.minecraft.glistering_melon_slice": "сверкающий ломтик арбуза",
  "item.minecraft.bat_spawn_egg": "яйцо призыва летучей мыши",
  "item.minecraft.bee_spawn_egg": "яйцо призыва пчелы",
  "item.minecraft.blaze_spawn_egg": "яйцо призыва всполоха",
  "item.minecraft.cat_spawn_egg": "яйцо призыва кошки",
  "item.minecraft.cave_spider_spawn_egg": "яйцо призыва пещерного паука",
  "item.minecraft.chicken_spawn_egg": "яйцо призыва курицы",
  "item.minecraft.cod_spawn_egg": "яйцо призыва трески",
  "item.minecraft.cow_spawn_egg": "яйцо призыва коровы",
  "item.minecraft.creeper_spawn_egg": "яйцо призыва крипера",
  "item.minecraft.dolphin_spawn_egg": "яйцо призыва дельфина",
  "item.minecraft.donkey_spawn_egg": "яйцо призыва осла",
  "item.minecraft.drowned_spawn_egg": "яйцо призыва утопленника",
  "item.minecraft.elder_guardian_spawn_egg": "яйцо призыва древнего стража",
  "item.minecraft.enderman_spawn_egg": "яйцо призыва эндермена",
  "item.minecraft.endermite_spawn_egg": "яйцо призыва эндермита",
  "item.minecraft.evoker_spawn_egg": "яйцо призыва заклинателя",
  "item.minecraft.fox_spawn_egg": "яйцо призыва лисицы",
  "item.minecraft.ghast_spawn_egg": "яйцо призыва гаста",
  "item.minecraft.guardian_spawn_egg": "яйцо призыва стража",
  "item.minecraft.hoglin_spawn_egg": "яйцо призыва хоглина",
  "item.minecraft.horse_spawn_egg": "яйцо призыва лошади",
  "item.minecraft.husk_spawn_egg": "яйцо призыва кадавра",
  "item.minecraft.llama_spawn_egg": "яйцо призыва ламы",
  "item.minecraft.magma_cube_spawn_egg": "яйцо призыва магмового куба",
  "item.minecraft.mooshroom_spawn_egg": "яйцо призыва муухомора",
  "item.minecraft.mule_spawn_egg": "яйцо призыва мула",
  "item.minecraft.ocelot_spawn_egg": "яйцо призыва оцелота",
  "item.minecraft.panda_spawn_egg": "яйцо призыва панды",
  "item.minecraft.parrot_spawn_egg": "яйцо призыва попугая",
  "item.minecraft.phantom_spawn_egg": "яйцо призыва фантома",
  "item.minecraft.pig_spawn_egg": "яйцо призыва свиньи",
  "item.minecraft.piglin_spawn_egg": "яйцо призыва пиглина",
  "item.minecraft.pillager_spawn_egg": "яйцо призыва разбойника",
  "item.minecraft.polar_bear_spawn_egg": "яйцо призыва белого медведя",
  "item.minecraft.pufferfish_spawn_egg": "яйцо призыва иглобрюха",
  "item.minecraft.rabbit_spawn_egg": "яйцо призыва кролика",
  "item.minecraft.ravager_spawn_egg": "яйцо призыва разорителя",
  "item.minecraft.salmon_spawn_egg": "яйцо призыва лосося",
  "item.minecraft.sheep_spawn_egg": "яйцо призыва овцы",
  "item.minecraft.shulker_spawn_egg": "яйцо призыва шалкера",
  "item.minecraft.silverfish_spawn_egg": "яйцо призыва чешуйницы",
  "item.minecraft.skeleton_spawn_egg": "яйцо призыва скелета",
  "item.minecraft.skeleton_horse_spawn_egg": "яйцо призыва лошади-скелета",
  "item.minecraft.slime_spawn_egg": "яйцо призыва слизня",
  "item.minecraft.spider_spawn_egg": "яйцо призыва паука",
  "item.minecraft.squid_spawn_egg": "яйцо призыва спрута",
  "item.minecraft.stray_spawn_egg": "яйцо призыва зимогора",
  "item.minecraft.strider_spawn_egg": "яйцо призыва лавомерки",
  "item.minecraft.trader_llama_spawn_egg": "яйцо призыва ламы торговца",
  "item.minecraft.tropical_fish_spawn_egg": "яйцо призыва тропической рыбы",
  "item.minecraft.turtle_spawn_egg": "яйцо призыва черепахи",
  "item.minecraft.vex_spawn_egg": "яйцо призыва вредины",
  "item.minecraft.villager_spawn_egg": "яйцо призыва крестьянина",
  "item.minecraft.vindicator_spawn_egg": "яйцо призыва поборника",
  "item.minecraft.wandering_trader_spawn_egg": "яйцо призыва странствующего торговца",
  "item.minecraft.witch_spawn_egg": "яйцо призыва ведьмы",
  "item.minecraft.wither_skeleton_spawn_egg": "яйцо призыва визер-скелета",
  "item.minecraft.wolf_spawn_egg": "яйцо призыва волка",
  "item.minecraft.zoglin_spawn_egg": "яйцо призыва зоглина",
  "item.minecraft.zombie_spawn_egg": "яйцо призыва зомби",
  "item.minecraft.zombie_horse_spawn_egg": "яйцо призыва лошади-зомби",
  "item.minecraft.zombie_villager_spawn_egg": "яйцо призыва зомби-крестьянина",
  "item.minecraft.zombified_piglin_spawn_egg": "яйцо призыва зомбифицированного пиглина",
  "item.minecraft.experience_bottle": "пузырёк опыта",
  "item.minecraft.fire_charge": "огненный заряд",
  "item.minecraft.writable_book": "книга и перо",
  "item.minecraft.written_book": "завершённая книга",
  "item.minecraft.emerald": "изумруд",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "цветочный горшок",
  "item.minecraft.carrot": "морковь",
  "item.minecraft.potato": "картофель",
  "item.minecraft.baked_potato": "печёный картофель",
  "item.minecraft.poisonous_potato": "ядовитый картофель",
  "item.minecraft.map": "чистая карта",
  "item.minecraft.golden_carrot": "золотая морковь",
  "block.minecraft.skeleton_skull": "череп",
  "block.minecraft.wither_skeleton_skull": "череп визер-скелета",
  "block.minecraft.player_head": "голова игрока",
  "block.minecraft.zombie_head": "голова зомби",
  "block.minecraft.creeper_head": "голова крипера",
  "block.minecraft.dragon_head": "голова дракона",
  "item.minecraft.carrot_on_a_stick": "удочка с морковкой",
  "item.minecraft.warped_fungus_on_a_stick": "удочка с искажённым грибом",
  "item.minecraft.nether_star": "звезда незера",
  "item.minecraft.pumpkin_pie": "тыквенный пирог",
  "item.minecraft.firework_rocket": "фейерверк",
  "item.minecraft.firework_star": "пиротехническая звезда",
  "item.minecraft.enchanted_book": "чародейская книга",
  "item.minecraft.nether_brick": "незерский кирпич",
  "item.minecraft.quartz": "незер-кварц",
  "item.minecraft.tnt_minecart": "вагонетка с динамитом",
  "item.minecraft.hopper_minecart": "загрузочная вагонетка",
  "item.minecraft.prismarine_shard": "осколок призмарина",
  "item.minecraft.prismarine_crystals": "кристалл призмарина",
  "item.minecraft.rabbit": "сырая крольчатина",
  "item.minecraft.cooked_rabbit": "жареная крольчатина",
  "item.minecraft.rabbit_stew": "тушёный кролик",
  "item.minecraft.rabbit_foot": "кроличья лапка",
  "item.minecraft.rabbit_hide": "кроличья шкурка",
  "item.minecraft.armor_stand": "стойка для брони",
  "item.minecraft.iron_horse_armor": "железная конская броня",
  "item.minecraft.golden_horse_armor": "золотая конская броня",
  "item.minecraft.diamond_horse_armor": "алмазная конская броня",
  "item.minecraft.leather_horse_armor": "кожаная конская броня",
  "item.minecraft.lead": "поводок",
  "item.minecraft.name_tag": "бирка",
  "item.minecraft.command_block_minecart": "вагонетка с командным блоком",
  "item.minecraft.mutton": "сырая баранина",
  "item.minecraft.cooked_mutton": "жареная баранина",
  "block.minecraft.white_banner": "белый флаг",
  "block.minecraft.orange_banner": "оранжевый флаг",
  "block.minecraft.magenta_banner": "пурпурный флаг",
  "block.minecraft.light_blue_banner": "голубой флаг",
  "block.minecraft.yellow_banner": "жёлтый флаг",
  "block.minecraft.lime_banner": "лаймовый флаг",
  "block.minecraft.pink_banner": "розовый флаг",
  "block.minecraft.gray_banner": "серый флаг",
  "block.minecraft.light_gray_banner": "светло-серый флаг",
  "block.minecraft.cyan_banner": "бирюзовый флаг",
  "block.minecraft.purple_banner": "фиолетовый флаг",
  "block.minecraft.blue_banner": "синий флаг",
  "block.minecraft.brown_banner": "коричневый флаг",
  "block.minecraft.green_banner": "зелёный флаг",
  "block.minecraft.red_banner": "красный флаг",
  "block.minecraft.black_banner": "чёрный флаг",
  "item.minecraft.end_crystal": "кристалл энда",
  "item.minecraft.chorus_fruit": "плод хоруса",
  "item.minecraft.popped_chorus_fruit": "прожаренный плод хоруса",
  "item.minecraft.beetroot": "свёкла",
  "item.minecraft.beetroot_seeds": "семена свёклы",
  "item.minecraft.beetroot_soup": "свекольный суп",
  "item.minecraft.dragon_breath": "драконье дыхание",
  "item.minecraft.splash_potion": "взрывное несоздаваемое зелье□без эффектов",
  "item.minecraft.spectral_arrow": "спектральная стрела",
  "item.minecraft.tipped_arrow": "стрела, обработанная несоздаваемым зельем□без эффектов",
  "item.minecraft.lingering_potion": "несоздаваемое туманное зелье□без эффектов",
  "item.minecraft.shield": "щит",
  "item.minecraft.elytra": "элитры",
  "item.minecraft.spruce_boat": "еловая лодка",
  "item.minecraft.birch_boat": "берёзовая лодка",
  "item.minecraft.jungle_boat": "лодка из тропического дерева",
  "item.minecraft.acacia_boat": "акациевая лодка",
  "item.minecraft.dark_oak_boat": "лодка из тёмного дуба",
  "item.minecraft.totem_of_undying": "тотем бессмертия",
  "item.minecraft.shulker_shell": "панцирь шалкера",
  "item.minecraft.iron_nugget": "кусочек железа",
  "item.minecraft.knowledge_book": "книга знаний",
  "item.minecraft.debug_stick": "палочка отладки",
  "item.minecraft.music_disc_13": "пластинка□c418 — 13",
  "item.minecraft.music_disc_cat": "пластинка□c418 — cat",
  "item.minecraft.music_disc_blocks": "пластинка□c418 — blocks",
  "item.minecraft.music_disc_chirp": "пластинка□c418 — chirp",
  "item.minecraft.music_disc_far": "пластинка□c418 — far",
  "item.minecraft.music_disc_mall": "пластинка□c418 — mall",
  "item.minecraft.music_disc_mellohi": "пластинка□c418 — mellohi",
  "item.minecraft.music_disc_stal": "пластинка□c418 — stal",
  "item.minecraft.music_disc_strad": "пластинка□c418 — strad",
  "item.minecraft.music_disc_ward": "пластинка□c418 — ward",
  "item.minecraft.music_disc_11": "пластинка□c418 — 11",
  "item.minecraft.music_disc_wait": "пластинка□c418 — wait",
  "item.minecraft.music_disc_pigstep": "пластинка□лена рейн — pigstep",
  "item.minecraft.trident": "трезубец□□когда в ведущей руке:□+8 урон□-2.9 скорость атаки",
  "item.minecraft.phantom_membrane": "мембрана фантома",
  "item.minecraft.nautilus_shell": "раковина наутилуса",
  "item.minecraft.heart_of_the_sea": "сердце моря",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "загадочное рагу",
  "block.minecraft.loom": "ткацкий станок",
  "item.minecraft.flower_banner_pattern": "узор флага□цветок",
  "item.minecraft.creeper_banner_pattern": "узор флага□крипер",
  "item.minecraft.skull_banner_pattern": "узор флага□череп",
  "item.minecraft.mojang_banner_pattern": "узор флага□нечто",
  "item.minecraft.globe_banner_pattern": "узор флага□глобус",
  "item.minecraft.piglin_banner_pattern": "узор флага□рыло",
  "block.minecraft.composter": "компостница",
  "block.minecraft.barrel": "бочка",
  "block.minecraft.smoker": "коптильня",
  "block.minecraft.blast_furnace": "плавильная печь",
  "block.minecraft.cartography_table": "стол картографа",
  "block.minecraft.fletching_table": "стол лучника",
  "block.minecraft.grindstone": "точило",
  "block.minecraft.lectern": "кафедра",
  "block.minecraft.smithing_table": "стол кузнеца",
  "block.minecraft.stonecutter": "камнерез",
  "block.minecraft.bell": "колокол",
  "block.minecraft.lantern": "фонарь",
  "block.minecraft.soul_lantern": "фонарь душ",
  "item.minecraft.sweet_berries": "сладкие ягоды",
  "block.minecraft.campfire": "костёр",
  "block.minecraft.soul_campfire": "костёр душ",
  "block.minecraft.shroomlight": "грибосвет",
  "item.minecraft.honeycomb": "пчелиные соты",
  "block.minecraft.bee_nest": "пчелиное гнездо",
  "block.minecraft.beehive": "улей",
  "item.minecraft.honey_bottle": "бутылочка мёда",
  "block.minecraft.honey_block": "блок мёда",
  "block.minecraft.honeycomb_block": "блок пчелиных сот",
  "block.minecraft.lodestone": "магнетит",
  "block.minecraft.netherite_block": "незеритовый блок",
  "block.minecraft.ancient_debris": "древние обломки",
  "block.minecraft.target": "мишень",
  "block.minecraft.crying_obsidian": "плачущий обсидиан",
  "block.minecraft.blackstone": "чернит",
  "block.minecraft.blackstone_slab": "чернитная плита",
  "block.minecraft.blackstone_stairs": "чернитные ступеньки",
  "block.minecraft.gilded_blackstone": "золочёный чернит",
  "block.minecraft.polished_blackstone": "полированный чернит",
  "block.minecraft.polished_blackstone_slab": "плита из полированного чернита",
  "block.minecraft.polished_blackstone_stairs": "ступеньки из полированного чернита",
  "block.minecraft.chiseled_polished_blackstone": "резной полированный чернит",
  "block.minecraft.polished_blackstone_bricks": "полированно-чернитные кирпичи",
  "block.minecraft.polished_blackstone_brick_slab": "плита из полированно-чернитного кирпича",
  "block.minecraft.polished_blackstone_brick_stairs": "ступеньки из полированно-чернитного кирпича",
  "block.minecraft.cracked_polished_blackstone_bricks": "потрескавшиеся полированно-чернитные кирпичи",
  "block.minecraft.respawn_anchor": "якорь возрождения",
}
export const ru_ru = items; 
